import { Link } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function CategoryNav() {
  return (
    <section className="py-8 md:py-10" aria-labelledby="category-nav-title">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-5">
          <h2 id="category-nav-title" className="text-lg md:text-xl font-heading text-foreground-900">
            漫画分类
          </h2>
        </div>
        <div className="grid grid-cols-4 sm:grid-cols-4 md:grid-cols-8 gap-3">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="flex flex-col items-center gap-2 p-3 md:p-4 rounded-lg bg-background-100 hover:bg-primary-50 transition-colors group cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-full bg-primary-100 text-primary-500 group-hover:bg-primary-500 group-hover:text-white transition-all">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <span className="text-xs md:text-sm text-foreground-700 group-hover:text-primary-600 font-medium whitespace-nowrap transition-colors">
                {cat.name}
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}